import { Checkbox, FormLabel, OptionType, SearchableSelect, Textinput } from "shared";
import {
    ITemplateComponent,
    ITemplateCheckboxComponent
} from "entities/template";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useComponentsTranslations } from "../../../../lib/i18n";
import { VisibilityField } from "../../form_fields/visibility_field/visibility_field";
import { LabelField } from "../../form_fields/label_field/label_field";
import { TooltipField } from "../../form_fields/tooltip_field/tooltip_field";
import { useComponentValidateFunction } from "../../../../lib/hooks/useComponentValidateFunction";
import styles from "./component_form_checkbox.module.scss";

interface IComponentFormCheckboxProps {
    component: ITemplateCheckboxComponent;
    enLanguageEnabled: boolean;
    componentList: ITemplateComponent[];
    triggerValidate: number;
    onChange: (component: ITemplateComponent) => void;
}

export const ComponentFormCheckbox: React.FC<IComponentFormCheckboxProps> = React.memo(({
                                                                                            component,
                                                                                            enLanguageEnabled,
                                                                                            componentList,
                                                                                            triggerValidate,
                                                                                            onChange
                                                                                        }) => {
    const t = useComponentsTranslations();
    const { i18n } = useTranslation();
    const { validateTag } = useComponentValidateFunction();

    const options: OptionType[] = useMemo(() => [
        {
            label: t("yes"),
            value: "true"
        },
        {
            label: t("no"),
            value: "false"
        }
    ], [i18n.language]);

    const onFieldChange = (value: Partial<ITemplateCheckboxComponent>) => {
        onChange({
            ...component,
            ...value
        })
    };

    const defaultValue: boolean = component.defaultValue === true;

    return <div className={styles.container}>
        <LabelField component={component}
                    enLanguageEnabled={enLanguageEnabled}
                    title={t("formLabel")}
                    name="label-dynamic-input"
                    onChange={onFieldChange}/>

        <FormLabel title={t("formTag")} required={true}>
            <Textinput size="m"
                       value={component.name ? component.name : ""}
                       triggerValidate={triggerValidate}
                       validate={true}
                       validateFunc={validateTag}
                       onChange={(e) => onFieldChange({ name: e.target.value })}
                       view="outline"/>
        </FormLabel>

        <FormLabel title={t("defaultValue")}>
            <SearchableSelect options={options}
                              optionValue={options.find((o) => o.value === defaultValue.toString()) as OptionType}
                              onChange={(value) => onFieldChange({ defaultValue: value === "true" })}
                              isMulti={false}
                              isSearchable={true}/>
        </FormLabel>

        <VisibilityField
            component={component}
            componentList={componentList}
            onChange={onFieldChange}/>

        <TooltipField
            component={component}
            enLanguageEnabled={enLanguageEnabled}
            onChange={onFieldChange}
        />

        <div className={styles.checkboxGroup}>
            <Checkbox
                label={t("readonlyField")}
                size="m"
                onChange={() => onFieldChange({ readonly: !component.readonly })}
                checked={component.readonly}
            />
            <Checkbox
                label={t("rowGroup")}
                size="m"
                onChange={() => onFieldChange({ isRowGroup: !component.isRowGroup })}
                checked={component.isRowGroup}
            />
        </div>
    </div>;
});

